import { render, staticRenderFns } from "./root.vue?vue&type=template&id=183695c5"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"
import style0 from "./root.vue?vue&type=style&index=0&id=183695c5&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183695c5')) {
      api.createRecord('183695c5', component.options)
    } else {
      api.reload('183695c5', component.options)
    }
    module.hot.accept("./root.vue?vue&type=template&id=183695c5", function () {
      api.rerender('183695c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/root/root.vue"
export default component.exports